import { setAccessTokenAdminAction } from 'pages/admin/_redux/actions';
import { accessTokenAdminSelector } from 'pages/admin/_redux/selectors';
import { resetAccessTokenClienteAction } from 'pages/cliente/_redux/actions';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const LoginAdminSSO: React.FC = () => {

  const query = useQuery();

  const dispatch = useAppDispatch();
  const accessTokenAdmin = useAppSelector(accessTokenAdminSelector);
  const history = useHistory();

  useEffect(() => {
    const accessToken = query.get('accessToken');
    // supponiamo di avere in querystring il parametro userToken, che consentirà all'operatore banca di effettuare l'autenticazione
    if (accessToken) {
      dispatch(resetAccessTokenClienteAction());
      dispatch(setAccessTokenAdminAction(accessToken));
    } else {
      history.push(`/error-page`);
    }
  }, [history, query, dispatch]);

  useEffect(() => {
    if (accessTokenAdmin) {
      localStorage.setItem('accessTokenAdmin', accessTokenAdmin);
      // localStorage.removeItem('accessTokenCliente');
      history.push(`/admin/dashboard`);
    }
  }, [history, accessTokenAdmin]);

  return null;

}

export default LoginAdminSSO;



